import { render, staticRenderFns } from "./zhoubao.vue?vue&type=template&id=323c9fd3"
import script from "./zhoubao.vue?vue&type=script&lang=js"
export * from "./zhoubao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports